angular
	.module 'App.Service'
	.factory 'Guid', ->
		generate: ->
			now = do Date.now
			if angular.isDefined(performance) and angular.isFunction(performance.now)
				now += performance.now() # use high-precision timer if available

			guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace /[xy]/g, (c) ->
				r = (now + Math.random() * 16) % 16 | 0
				now = Math.floor now / 16
				(if c == 'x' then r else (r&0x7|0x8)).toString 16

			return guid.toUpperCase()

		# Generate random string.
		# @see https://stackoverflow.com/a/8084248/1346234
		randomString: (length = 6) ->
			randomString = ''

			# If Math.random() returns short number (e.g. 0.23) then string will be too short
			while randomString.length < length
				# Start from 2, because number is in fraction `0.###`
				randomString = Math.random().toString(36).substring(2, 2 + length)

			return randomString
